import { useState,useContext } from 'react'
import { Grid, Menu, MenuItem, Tooltip } from '@mui/material'
import { useNavigate,useLocation } from 'react-router-dom'
import { Context } from '../context/Context'

import './Header.css'
import { post } from '../utils/axios'

const Header = ({ firstName,lastName,branch }) => {

    const navigate = useNavigate()
    const location = useLocation()
    const context = useContext(Context)

    const [sortMenuOpen,setSortMenuOpen] = useState(false)
    const open = Boolean(sortMenuOpen)

    const handleClick = e => {
        setSortMenuOpen(e.currentTarget)
    }

    const handleClose = () => {
        setSortMenuOpen(null)
    }

    const logout = () => {
        post('User/LogOutUser')
        localStorage.removeItem('token')
        context.setProfile({roleId: 0})
        context.setGuildId(0)
        context.setBasket([])
        context.setCards([])
        context.setAddress({})
        context.setlatitude(null)
        context.setLongitude(null)
        context.setCurrentProvinceId(0)
        context.setCurrentCityId(0)
        context.setWalletPayment(false)
        setTimeout(() => {
            navigate('/')
        },300)
    }

    return (
        <Grid container spacing={2} marginTop={0.1} marginBottom={2.2}>
            <Grid item xs={8} onClick={handleClick}>
                <img src="/assets/img/avatar.png" id="avatar" />
                <div id="user-name">{`${firstName || ''} ${lastName || ''}`}</div>
                <div id="office-name">{branch || ''}</div>
            </Grid>
            <Menu anchorEl={sortMenuOpen} open={open} onClose={handleClose}>
                <MenuItem onClick={logout} sx={{minWidth: 100,textAlign: 'center'}}>خروج</MenuItem>
            </Menu>
            <Grid item xs={4}>
                <Grid container spacing={1} marginTop={-.35}>
                    {context.basket.length ? <Grid item xs={6}>
                        <Tooltip title="سبد خرید">
                            <div className="header-icon-btn" onClick={() => navigate('/app/basket')}>{context.basket.length ? <div className="basket-count-badge">{context.basket.length}</div> : ''}<i className="fal fa-basket-shopping-simple"></i></div>
                        </Tooltip>
                    </Grid> : <Grid item xs={6}>
                        <Tooltip title="اسکن QR Code">
                            <div className="header-icon-btn" onClick={() => navigate('/app/others/qrcode')}><i className="fal fa-qrcode"></i></div>
                        </Tooltip>
                    </Grid>}
                    {location.pathname === '/app' ? <Grid item xs={6}>
                        <Tooltip title="سایر صفحات">
                            <div className="header-icon-btn" onClick={() => navigate('/app/others')}><i className="fal fa-grid-horizontal"></i></div>
                        </Tooltip>
                    </Grid> : location.pathname.includes('/app/callback') ? <Grid item xs={6}>
                        <Tooltip title="بازگشت به خانه">
                            <div className="header-icon-btn" onClick={() => navigate('/app')}><i className="fal fa-home"></i></div>
                        </Tooltip>
                    </Grid> : <Grid item xs={6}>
                        <Tooltip title="بازگشت">
                            <div className="header-icon-btn" onClick={() => navigate(-1)}><i className="fal fa-arrow-left"></i></div>
                        </Tooltip>
                    </Grid>}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Header